import { Component, AfterContentChecked, ContentChildren, Input, Output, QueryList, EventEmitter } from '@angular/core';
import { NgbTabset, NgbTabsetConfig, NgbTab, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-tabset-collapse',
  templateUrl: './tabset-collapse.component.html',
  styleUrls: ['./tabset-collapse.component.scss']
})
export class TabsetCollapseComponent implements AfterContentChecked {
  @ContentChildren(NgbTab) tabs: QueryList<NgbTab>;

  /**
   * An identifier of an initially selected (active) tab. Use the "select" method to switch a tab programmatically.
   */
  @Input() activeId: string;

  /**
   * Whether the closed tabs should be hidden without destroying them
   */
  @Input() destroyOnHide = true;

  /**
   * The horizontal alignment of the nav with flexbox utilities.
   * Can be one of 'start', 'center', 'end', 'fill' or 'justified'
   */
  @Input() justify: 'start' | 'center' | 'end' | 'fill' | 'justified';

  /**
   * Type of navigation to be used for tabs. Can be one of 'tabs' or 'pills'.
   */
  @Input() type: 'tabs' | 'pills';

  /**
   * A tab change event fired right before the tab selection happens. See NgbTabChangeEvent for payload details
   */
  @Output() tabChange = new EventEmitter<NgbTabChangeEvent>();

  constructor(config: NgbTabsetConfig) {
    this.type = config.type;
    this.justify = config.justify;
  }

  /**
   * Selects the tab with the given id and shows its associated pane.
   * Any other tab that was previously selected becomes unselected and its associated pane is hidden.
   */
  select(tabId: string) {
    const selectedTab = this._getTabById(tabId);
    if (selectedTab && !selectedTab.disabled) {
      let defaultPrevented = false;

      this.tabChange.emit(
        { activeId: this.activeId, nextId: selectedTab.id, preventDefault: () => { defaultPrevented = true; } });

      if (this.activeId === selectedTab.id) {
        this.activeId = null;
        return;
      }

      if (!defaultPrevented) {
        this.activeId = selectedTab.id;
      }
    }
  }

  ngAfterContentChecked() {
    // auto-correct activeId that might have been set incorrectly as input
    const activeTab = this._getTabById(this.activeId);
    this.activeId = activeTab ? activeTab.id : null;
  }

  private _getTabById(id: string): NgbTab {
    const tabsWithId: NgbTab[] = this.tabs.filter(tab => tab.id === id);
    return tabsWithId.length ? tabsWithId[0] : null;
  }

}



// WEBPACK FOOTER //
// ./ts/app/footer/tabset-collapse/tabset-collapse.component.ts